import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';
import { buildLoginUrl } from '../services/apiService';

export default function AuthGate({ children }: { children: React.ReactNode }): React.ReactElement | null {
  const { isLoaded, isSignedIn } = useAuth();

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      window.location.href = buildLoginUrl(window.location.pathname + window.location.search);
    }
  }, [isLoaded, isSignedIn]);

  if (!isLoaded || !isSignedIn) return null;
  return <>{children}</>;
}
